<template>
<div  style="padding:10px;">
<vue-qr  :text="qrcontent" :size="300"></vue-qr>
<van-cell-group  v-show="showText">
   <van-cell border=false>
   <div> 通过E精灵扫描以上二维码，扫码成功后，如听到”滴 滴“两声后，则队列清除成功。</div>
   </van-cell>
</van-cell-group>
</div>
</template>
<script>
import Vue from 'vue';
import { Field } from 'vant';
import vueQr from 'vue-qr'
import { Cell, CellGroup } from 'vant';
import { Button } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Toast } from 'vant';

Vue.use(Toast);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Button);
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(vueQr);
export default {
		name: 'PrintClear',
		data() {
			return {
        qrcontent: 'CMD_CANCEL',
        showText:true
      }
		},methods:{


    },mounted(){
      


    },
   components: {
      vueQr
    }
    
}
</script>


// WEBPACK FOOTER //
// src/components/PrintClear.vue